import tw from "tailwind-styled-components"


export const Container = tw.div `
bg-bluebackground 
h-screen
pt-20
md:pt-[6rem]
pb-10
`